<h1 class="header header--1" [innerHTML]="block.data.text ? block.data.text : block.data.heading" [attr.id]="parseBlockId(block)"
    [ngClass]="{'header--page-icon': block.data.showIcon && pageIcon}"
    [ngStyle]="{backgroundImage: block.data.showIcon && pageIcon ? 'url(' + pageIcon + ')' : null}"></h1>
